import DOMPurify from 'dompurify'
import Vue from 'vue'

// Options available from: https://github.com/cure53/DOMPurify#can-i-configure-dompurify

Vue.directive('sanitize-html', {
  bind: (el, binding) => {
    el.innerHTML = DOMPurify.sanitize(binding.value, {
      ALLOWED_ATTR: ['target', 'href', 'rel'],
    })
  },
  update: (el, binding) => {
    el.innerHTML = sanitizeAllowLinks(binding.value)
  },
  unbind: (el) => {
    el.innerHTML = ''
  },
})

Vue.directive('sanitize-html-strict-style', {
  bind: (el, binding) => {
    el.innerHTML = sanitizeStrict(binding.value)
  },
  update: (el, binding) => {
    el.innerHTML = sanitizeStrict(binding.value)
  },
  unbind: (el) => {
    el.innerHTML = ''
  },
})

Vue.directive('sanitize-html-no-format-style', {
  bind: (el, binding) => {
    el.innerHTML = sanitizeNoFormat(binding.value)
  },
  update: (el, binding) => {
    el.innerHTML = sanitizeNoFormat(binding.value)
  },
  unbind: (el) => {
    el.innerHTML = ''
  },
})

const sanitizeAllowLinks = (value: string) => {
  return DOMPurify.sanitize(value, {
    ALLOWED_ATTR: ['target', 'href', 'rel'],
  })
}

const sanitizeStrict = (value: string) => {
  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: ['b', 'i', 'strong', 'em'],
  })
}

const sanitizeNoFormat = (value: string) => {
  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [],
  })
}
